import { HandySvg } from 'handy-svg';
import iconRightArrow from '../../assets/icons/svg-sprite/arrow-right.svg';

import { news } from "../../lib/api/api";
import { useState, useEffect } from "react";
import { Link } from 'react-router-dom';
import AnnouncementCard from '../../components/announcementCard/AnnouncementCard';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination, Autoplay } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const Announcements = () => {
    const [cards, setCards] = useState([]);

    useEffect(() => {
        news.newsList(3, 3, 0)
            .then((res) => {
                setCards(res);
            })
            .catch((err) => {
                console.log(err);
            });
    }, []);

    return (
        <>
            <section className="announcements page__announcements">
                <header className="announcements__header">
                    <div className="page-container announcements__header-container">
                        <h3 className="announcements__title title title--h2">Смотрите на наших каналах</h3>
                        <Link className="announcements__top-link link arrow-link arrow-link--blue" to='//telekarta.tv/announcements/'>Все анонсы
                            <HandySvg className="svg-icon arrow-link__arrow" src={iconRightArrow} width="16" height="16"/>
                        </Link>
                    </div>
                </header>
                <div className="announcements__body">
                    <Swiper
                        slidesPerView={1}
                        modules={[Pagination, Autoplay]}
                        initialSlide={1}
                        pagination={{ clickable: true }}
                        className="announcements__list"
                        autoplay={{ delay: 3000 }}
                        breakpoints={{
                            768: {
                              slidesPerView: 2
                            },
                            1230: {
                                slidesPerView: 3
                            }
                        }}
                    >
                        {cards.map(card => (
                            <SwiperSlide className="announcements__item">
                                <AnnouncementCard data={card}/>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            </section>
        </>
    );
};

export default Announcements;